import img1 from "../../assets/Images/Event Booking/Create-Receipt-Voucher.png"
import img2 from "../../assets/Images/Event Booking/Receipt-Voucher.png"

export default function ReceiptVouchers() {
  return (
    <section id="receipt-vouchers" className="space-y-16">

      {/* SECTION TITLE */}
      <div>
        <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
          2.3 Receipt Vouchers
        </h2>
        <p className="text-slate-600 max-w-3xl">
          Receipt Vouchers are used to record payments received from customers
          against confirmed bookings. This module ensures accurate payment
          tracking, transparency, and proper financial reconciliation.
        </p> <br />
        <p className="text-slate-600">
          The Receipt Voucher module maintains a complete log of all payments
          received. Each voucher is linked to a booking and automatically updates
          the received and due amounts across the system.
        </p>
      </div>

      {/* OVERVIEW */}
      {/* <section className="bg-white border-l border-[#C9A24E] p-4">
        <h3 className="text-lg font-semibold mb-2">
          Overview
        </h3>
        
      </section> */}

      {/* FILTERS */}
      <section className="">
        <div>
          <h3 className="font-semibold mb-2">
            Receipt Voucher Filters
          </h3>
          <p className="text-slate-600 mb-3">
            Filters at the top of the screen help staff quickly locate specific
            vouchers based on date and payment method.
          </p>

          <ul className="list-disc pl-5 text-slate-600 space-y-1">
            <li>Date range (From / To)</li>
            <li>Payment method (Cash, Online, Bank, etc.)</li>
            <li>Instant recalculation of totals</li>
          </ul>
        </div>

        
      </section>

      {/* ADD NEW RECEIPT */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Add New Receipt Voucher
        </h3>

        <p className="text-slate-600 mb-3">
          The <strong>Add New Receipt Voucher</strong> button is located in the
          top section of the page. Clicking this button opens the receipt entry
          form.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Used when receiving any payment from a customer</li>
          <li>Links payment directly to a booking</li>
          <li>Automatically updates booking balance</li>
        </ul>
      </section>

      {/* RECEIPT FORM */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Create Receipt Voucher Form
        </h3>

        <p className="text-slate-600 mb-4">
          This form records the payment details received from the customer. Each
          field plays an important role in financial accuracy.
        </p>

        <div className="">

          <div>
            <ul className="list-disc pl-5 text-slate-600 space-y-1">
              <li>Receipt Voucher Number (auto-generated)</li>
              <li>Booking Number (linked booking)</li>
              <li>Receipt Date</li>
              <li>Received Amount</li>
              <li>Received From (customer name)</li>
              <li>Payment Method (Cash, Online, etc.)</li>
            </ul>
          </div>

          <div className="rounded-lg p-4 mt-4">
            <img src={img1} alt="" />
          </div>

        </div>
      </section>

      {/* SAVE LOGIC */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Saving the Receipt Voucher
        </h3>

        <p className="text-slate-600 mb-3">
          Once the form is completed and saved, EventFlow immediately reflects
          the payment across all relevant modules.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Booking received amount is updated</li>
          <li>Due balance is recalculated</li>
          <li>Voucher appears in receipt list</li>
          <li>Financial reports are updated</li>
        </ul>
      </section>

      {/* RECEIPT TABLE */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Receipt Voucher List Table
        </h3>

        <p className="text-slate-600 mb-4">
          The table displays all receipt vouchers recorded in the system.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Receipt voucher number</li>
          <li>Linked booking number</li>
          <li>Receipt date</li>
          <li>Received amount</li>
          <li>Payment method</li>
          <li>Action buttons</li>
        </ul>

        <div className="rounded-lg p-4  mt-4">
          <img src={img2} alt="" />
        </div>
      </section>

      {/* ACTIONS */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Available Actions
        </h3>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>
            <strong>Invoice</strong> – Generates and displays the receipt invoice
          </li>
          <li>
            <strong>Edit</strong> – Allows modification of voucher details
          </li>
        </ul>
      </section>

      {/* WHY IMPORTANT */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Why Receipt Vouchers Matter
        </h3>

        <p className="text-slate-600 max-w-3xl">
          Receipt vouchers ensure accurate cash flow tracking, eliminate payment
          disputes, and provide a clear audit trail for accounting and reporting
          purposes.
        </p>
      </section>

    </section>
  );
}
